interface StepTwoProps {
  nextStep: () => void;
  likelyHoodOfReturning: number;
  setLikelyHoodOfReturning: (value: number) => void;
}

export const StepTwo = ({ nextStep, likelyHoodOfReturning, setLikelyHoodOfReturning }: StepTwoProps) => (
  <div>
    <div className="font-medium text-sm text-black leading-tight mb-2">
      ¿Qué tan probable es que vuelvas a probar Holos en el futuro?
    </div>
    
    <div className="space-y-4">
      {[
        { value: 5, label: 'Muy probable' },
        { value: 4, label: 'Algo probable' },
        { value: 3, label: 'Ni probable ni improbable' },
        { value: 2, label: 'Algo improbable' },
        { value: 1, label: 'Muy improbable' }
      ].map(({ value, label }) => (
        <div
          key={value}
          onClick={() => setLikelyHoodOfReturning(value)}
          className={`relative flex items-center p-4 pl-12 border-2 rounded-lg cursor-pointer transition-colors ${
            likelyHoodOfReturning === value 
              ? 'border-holos-dark bg-holos-dark/10' 
              : 'border-gray-300 hover:border-gray-400'
          }`}
        >
          <div className={`absolute left-4 w-6 h-6 rounded-full flex items-center justify-center ${
            likelyHoodOfReturning === value ? 'bg-holos-dark' : 'bg-gray-300'
          }`}>
            {likelyHoodOfReturning === value && (
              <span className="text-white text-sm">✓</span>
            )}
          </div>
          <div className="text-black font-semibold">{label}</div>
        </div>
      ))}
    </div>
    
    <button
      className="w-full bg-holos-dark text-white py-3 px-4 rounded-lg font-semibold uppercase mt-6 hover:bg-holos-dark/80 disabled:opacity-50 cursor-pointer"
      onClick={nextStep}
      disabled={likelyHoodOfReturning < 1}
    >
      Siguiente
    </button>
  </div>
);